/**
 * ticketflow/servers — accès (renderer) à la liste locale des serveurs.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Persistée en ORM/SQLite dans le process MAIN (voir electron/servers-store.js) et
 * exposée via le pont IPC `window.adminServers`. En dev navigateur pur (hors
 * Electron) le pont est absent → mode dégradé : repli sur l'URL d'env.
 */
const bridge = () => (typeof window !== 'undefined' ? window.adminServers : null);

/** Le store local (Electron/ORM) est-il disponible ? (false en navigateur pur). */
export function hasServerStore() {
  return Boolean(bridge());
}

export async function listServers() {
  const b = bridge();
  return b ? (await b.list()) || [] : [];
}

export async function addServer(server) {
  const b = bridge();
  return b ? b.add(server) : null;
}

export async function removeServer(id) {
  const b = bridge();
  return b ? b.remove(id) : null;
}

export async function setActiveServer(id) {
  const b = bridge();
  return b ? b.setActive(id) : null;
}

export async function getActiveServer() {
  const b = bridge();
  return b ? b.getActive() : null;
}

/** URL du serveur actif, sinon `fallback`. */
export async function getActiveServerUrl(fallback) {
  const s = await getActiveServer();
  return (s && s.url) || fallback || '';
}
